
import state from './myActivitiesState.js'
import * as mutations from './myActivitiesMutations.js'
import * as actions from './myActivitiesActions.js'
import * as getters from './myActivitiesGetters.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}